<app-breadcrumb [title]="'Quejas'" [items]="['Talento Humano']" [active_item]="'Quejas'"></app-breadcrumb>

<div class="container-fluid programa-form-wrap">
    <div class="card shadow-sm border-0">
        <div class="card-header bg-primary text-white d-flex align-items-center">
            <i class="icofont icofont-file-document me-2"></i>
            <h5 class="mb-0"><strong>QUEJAS</strong></h5>
        </div>

        <div class="card-body">
            <ul ngbNav #quejaTab="ngbNav" [(activeId)]="activeTab" class="nav-tabs">

                <!-- ===================== TAB 1: FORMULARIO ===================== -->
                <li [ngbNavItem]="1">
                    <a ngbNavLink>
                        <strong><i class="icofont icofont-plus me-1"></i> FORMULARIO QUEJA</strong>
                    </a>

                    <ng-template ngbNavContent>
                        <form [formGroup]="quejaForm" (ngSubmit)="guardar()" class="pt-3" novalidate>

                            <div class="card border-0 shadow-sm mb-3">
                                <div class="card-body">
                                    <div class="row g-3">

                                        <!-- Colaborador -->
                                        <div class="col-md-4">
                                            <label class="form-label text-dark">
                                                Colaborador: <span class="text-danger">*</span>
                                            </label>

                                            <ng-select [items]="colaboradores" bindLabel="nombreCompleto"
                                                bindValue="cedula" [loading]="cargandoColaboradores" [searchable]="true"
                                                [clearable]="true" placeholder="Seleccione un colaborador..."
                                                formControlName="id_colaborador" [ngClass]="{
            'is-invalid':
                quejaForm.get('id_colaborador')?.touched &&
                quejaForm.get('id_colaborador')?.invalid
        }">

                                                <ng-template ng-option-tmp let-colaborador="item">
                                                    <div>{{ colaborador.nombreCompleto }} - {{ colaborador.cargo }}
                                                    </div>
                                                </ng-template>

                                            </ng-select>

                                            <div class="invalid-feedback" *ngIf="
            quejaForm.get('id_colaborador')?.invalid &&
            quejaForm.get('id_colaborador')?.touched
        ">
                                                Debes seleccionar un colaborador.
                                            </div>
                                        </div>

                                        <!-- Tipo -->
                                        <div class="col-md-4">
                                            <label class="form-label text-dark">
                                                Tipo: <span class="text-danger">*</span>
                                            </label>
                                            <ng-select [items]="tipoquejas" bindLabel="descripcion" bindValue="id"
                                                [loading]="cargandoTipoQuejas"
                                                placeholder="Seleccione un colaborador..." formControlName="tipo"
                                                [ngClass]="{ 'is-invalid': quejaForm.get('tipo')?.touched && quejaForm.get('tipo')?.invalid }">
                                            </ng-select>
                                            <div class="invalid-feedback"
                                                *ngIf="quejaForm.get('tipo')?.invalid && quejaForm.get('tipo')?.touched">
                                                El tipo es obligatorio.
                                            </div>
                                        </div>

                                        <!-- Origen -->
                                        <div class="col-md-4">
                                            <label class="form-label text-dark">
                                                Origen: <span class="text-danger">*</span>
                                            </label>

                                            <ng-select [items]="origenquejas" bindLabel="descripcion" bindValue="id"
                                                [loading]="cargandoOrigenQuejas"
                                                placeholder="Seleccione un colaborador..." formControlName="origen"
                                                [ngClass]="{ 'is-invalid': quejaForm.get('origen')?.touched && quejaForm.get('origen')?.invalid }">
                                            </ng-select>
                                            <div class="invalid-feedback"
                                                *ngIf="quejaForm.get('origen')?.invalid && quejaForm.get('origen')?.touched">
                                                El origen es obligatorio.
                                            </div>
                                        </div>

                                        <!-- Fecha de la queja -->
                                        <div class="col-md-4">
                                            <label class="form-label text-dark">
                                                Fecha de la queja: <span class="text-danger">*</span>
                                            </label>
                                            <input type="date" class="form-control" formControlName="fecha_queja"
                                                [class.is-invalid]="quejaForm.get('fecha_queja')?.invalid && quejaForm.get('fecha_queja')?.touched">
                                            <div class="invalid-feedback"
                                                *ngIf="quejaForm.get('fecha_queja')?.invalid && quejaForm.get('fecha_queja')?.touched">
                                                La fecha es obligatoria.
                                            </div>
                                        </div>

                                        <!-- Estado de gestión -->
                                        <div class="col-md-4">
                                            <label class="form-label text-dark">
                                                Estado de gestión: <span class="text-danger">*</span>
                                            </label>

                                            <ng-select [items]="estadosPlan" bindLabel="descripcion" bindValue="id"
                                                placeholder="Seleccione..." formControlName="estado_gestion">
                                            </ng-select>
                                        </div>

                                        <!-- Fecha de respuesta -->
                                        <div class="col-md-4">
                                            <label class="form-label text-dark">
                                                Fecha de respuesta:
                                            </label>
                                            <input type="date" class="form-control" formControlName="fecha_respuesta">
                                        </div>

                                        <!-- Respuesta -->
                                        <div class="col-md-6">
                                            <label class="form-label text-dark">
                                                Respuesta:
                                            </label>
                                            <textarea class="form-control" rows="2" formControlName="respuesta"
                                                placeholder="Respuesta o gestión dada a la queja (opcional)"></textarea>
                                        </div>

                                        <div class="col-md-6">
                                            <label class="form-label text-dark">
                                                Motivo: <span class="text-danger">*</span>
                                            </label>
                                            <textarea class="form-control" rows="2" formControlName="motivo"
                                                placeholder="Describa el motivo de la queja"
                                                [class.is-invalid]="quejaForm.get('motivo')?.invalid && quejaForm.get('motivo')?.touched"></textarea>
                                            <div class="invalid-feedback"
                                                *ngIf="quejaForm.get('motivo')?.invalid && quejaForm.get('motivo')?.touched">
                                                El motivo es obligatorio.
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center gap-2 mt-4">
                                <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">
                                    <span *ngIf="!guardando">
                                        <i class="icofont icofont-save me-1"></i>
                                        {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                                    </span>
                                    <span *ngIf="guardando">
                                        <span class="spinner-border spinner-border-sm me-1"></span>
                                        {{ modoEdicion ? 'Actualizando...' : 'Guardando...' }}
                                    </span>
                                </button>

                                <button type="button" class="btn btn-secondary px-4" *ngIf="modoEdicion"
                                    (click)="cancelarEdicion()" [disabled]="guardando">
                                    <i class="icofont icofont-close me-1"></i>Cancelar edición
                                </button>
                            </div>

                        </form>
                    </ng-template>
                </li>

                <!-- ===================== TAB 2: LISTADO ===================== -->
                <li [ngbNavItem]="2">
                    <a ngbNavLink><strong><i class="icofont icofont-listine-dots me-1"></i> LISTADO
                            QUEJAS</strong></a>
                    <ng-template ngbNavContent>
                        <div class="card card-absolute rounded mt-3 border-0 shadow-sm">
                            <div class="card-body pt-3">

                                <div *ngIf="cargandoListado" class="text-center py-4">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Cargando...</span>
                                    </div>
                                    <p class="mt-2 mb-0">Cargando quejas...</p>
                                </div>

                                <div class="row mb-3 align-items-center" *ngIf="!cargandoListado">
                                    <div class="col-md-2">
                                        <select class="form-select" [(ngModel)]="filtroEstado"
                                            (change)="aplicarFiltro()">
                                            <option [ngValue]="null">Todos</option>
                                            <option [ngValue]="1">Activos</option>
                                            <option [ngValue]="0">Inactivos</option>
                                        </select>
                                    </div>
                                    <div class="col-md-2">
                                        <select class="form-select" [(ngModel)]="filtroEstadoGestion"
                                            (change)="aplicarFiltro()">
                                            <option value="">Toda gestión</option>
                                            <option *ngFor="let eg of estadosGestion" [value]="eg">{{ eg }}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-4 ms-auto">
                                        <div class="input-group">
                                            <input type="text" class="form-control"
                                                placeholder="Buscar por motivo, tipo u origen..." [(ngModel)]="filtro"
                                                (input)="aplicarFiltro()" />
                                            <span class="input-group-text">
                                                <i class="fa fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="!cargandoListado" class="table-responsive mt-2">
                                    <ng-container *ngIf="quejasFiltradas?.length > 0; else sinDatos">
                                        <table id="tblQuejas" class="table table-bordered table-hover align-middle">
                                            <thead class="bg-primary text-white">
                                                <tr>
                                                    <th class="text-center">COLABORADOR</th>
                                                    <th class="text-center">TIPO</th>
                                                    <th class="text-center">ORIGEN</th>
                                                    <th class="text-center">FECHA QUEJA</th>
                                                    <th class="text-center">MOTIVO</th>
                                                    <th class="text-center">ESTADO GESTIÓN</th>
                                                    <th class="text-center">ESTADO</th>
                                                    <th class="text-center">ACCIONES</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let queja of quejasFiltradas | paginate: { itemsPerPage: pageSize, currentPage: page }">
                                                    <td class="text-center">{{
                                                        queja.ColaboradorQuejaData?.nombreCompleto || '-' }}</td>
                                                    <td class="text-center">{{ queja.TipoQuejaData?.descripcion || '-'
                                                        }}</td>
                                                    <td class="text-center">{{ queja.OrigenQuejaData?.descripcion || '-'
                                                        }}</td>
                                                    <td class="text-center">{{ queja.fecha_queja | date:'dd/MM/yyyy' ||
                                                        '-' }}</td>
                                                    <td class="text-center text-truncate" style="max-width: 260px;">{{
                                                        queja.motivo || '-' }}</td>
                                                    <td class="text-center">
                                                        <span class="badge rounded-pill bg-info">
                                                            {{ queja.EstadoGestionData?.descripcion || '-' }}
                                                        </span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="badge rounded-pill"
                                                            [ngClass]="Number(queja.estado) === 1 ? 'bg-success' : 'bg-secondary'">
                                                            {{ Number(queja.estado) === 1 ? 'ACTIVO' : 'INACTIVO' }}
                                                        </span>
                                                    </td>
                                                    <td class="text-center">
                                                        <div class="d-flex justify-content-center gap-1">
                                                            <button
                                                                class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                                                *ngIf="Number(queja.estado) === 1" ngbTooltip="Editar"
                                                                (click)="!cargandoEdicion && editarQueja(queja)">
                                                                <i class="icofont icofont-pencil"
                                                                    style="font-size: .85rem;"></i>
                                                                <span class="spinner-border spinner-border-sm"
                                                                    *ngIf="cargandoEdicion" role="status"></span>
                                                            </button>
                                                            <button
                                                                class="btn btn-sm btn-outline-info rounded-pill btn-rounded"
                                                                *ngIf="Number(queja.estado) === 1"
                                                                ngbTooltip="Ver Seguimiento"
                                                                (click)="verSeguimiento(queja)">
                                                                <i class="icofont icofont-eye"
                                                                    style="font-size: .85rem;"></i>
                                                            </button>
                                                            <button
                                                                class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                                                *ngIf="Number(queja.estado) === 1"
                                                                ngbTooltip="Inactivar"
                                                                (click)="cambiarEstado(queja, 0)">
                                                                <i class="icofont icofont-close"
                                                                    style="font-size: .85rem;"></i>
                                                            </button>
                                                            <button
                                                                class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                                                *ngIf="Number(queja.estado) !== 1"
                                                                (click)="cambiarEstado(queja, 1)" ngbTooltip="Activar">
                                                                <i class="icofont icofont-check"
                                                                    style="font-size: .85rem;"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </ng-container>

                                    <ng-template #sinDatos>
                                        <div class="text-center py-4 text-primary">No hay quejas registradas.</div>
                                    </ng-template>
                                </div>
                                <div class="d-flex justify-content-between align-items-center mt-4">
                                    <div class="d-flex align-items-center">
                                        <label for="pageSizeQuejas" class="me-2">Mostrar:</label>
                                        <select id="pageSizeQuejas" class="form-select w-auto" [(ngModel)]="pageSize"
                                            (change)="page = 1">
                                            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{
                                                size }}</option>
                                        </select>
                                        <span class="ms-2">registros por página</span>
                                    </div>

                                    <div class="text-center flex-grow-1">
                                        Total Registros:
                                        <a class="badge badge-primary"><b>{{ quejasFiltradas?.length || 0
                                                }}</b></a>
                                    </div>

                                    <div class="text-end paginador-personalizado">
                                        <pagination-controls (pageChange)="page = $event" [maxSize]="5"
                                            [directionLinks]="true" [autoHide]="true" previousLabel="Anterior"
                                            nextLabel="Siguiente"></pagination-controls>
                                    </div>
                                </div>

                                <div class="mt-4">
                                    <div class="btn-showcase text-center">
                                        <button class="btn btn-outline-success-2x" type="button"
                                            ngbTooltip="Exportar a Excel"
                                            (click)="exportarExcel('tblQuejas','listado_quejas')">
                                            <i class="icofont icofont-file-excel"></i> EXCEL
                                        </button>
                                        <button class="btn btn-outline-danger-2x" type="button"
                                            ngbTooltip="Exportar a PDF"
                                            (click)="exportToPDF('tblQuejas','listado_quejas','Listado de quejas')">
                                            <i class="icofont icofont-file-pdf"></i> PDF
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </li>

            </ul>

            <div [ngbNavOutlet]="quejaTab" class="mt-2"></div>
        </div>
    </div>
</div>